import React from "react";
import Routes from "./Routes";
import AuthProvider from "./components/AuthProvider";
import UpgradeModalProvider from "./contexts/UpgradeModalContext";

import { captureRefFromUrl } from './lib/affiliateRef';
// Capture affiliate ref from URL on app load (60-day persistence)
if (typeof window !== 'undefined') {
  captureRefFromUrl();
}

function App() {
  return (
    <AuthProvider>
      <UpgradeModalProvider>
        <Routes />
      </UpgradeModalProvider>
    </AuthProvider>
  );
}

export default App;